import { render, staticRenderFns } from "./Pruebas.vue?vue&type=template&id=c2225dc0&scoped=true&"
import script from "./Pruebas.vue?vue&type=script&lang=js&"
export * from "./Pruebas.vue?vue&type=script&lang=js&"
import style0 from "./Pruebas.vue?vue&type=style&index=0&id=c2225dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2225dc0",
  null
  
)

export default component.exports